import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=6f8a27b0&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Group.vue?vue&type=style&index=1&id=6f8a27b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a27b0",
  null
  
)

export default component.exports